export default __webpack_public_path__ + "static/emulador-23bd60ba04e19ef7f5bc2b20adad3e3a.png";